/* eslint-disable formatjs/enforce-id */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Static Texts
  nextButton: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  previousButton: {
    id: 'JJNc3c',
    defaultMessage: 'Previous',
  },
  sliderLow: {
    id: '477I0g',
    defaultMessage: 'Low',
  },
  sliderMedium: {
    id: 'ovJ26C',
    defaultMessage: 'Medium',
  },
  sliderHigh: {
    id: 'AxMhQr',
    defaultMessage: 'High',
  },
  // steps content
  introTitle: {
    id: 'OP8vfe',
    defaultMessage: 'Responsible AI maturity assessment for organizations',
  },
  introCopy: {
    id: '74dTvv',
    defaultMessage: `Are you curious about how you measure up in your responsible AI journey?`,
  },
  intro2Copy: {
    id: 'w8ffUV',
    defaultMessage: `
    Start your assessment to find out how well prepared your organization is to scale AI responsibly by answering these short questions across the three main themes of strategy, technology and culture. For each question, select the answer that most closely aligns with your organization’s current state.`,
  },
  introButton: {
    id: 'SR2+Sb',
    defaultMessage: 'Let’s start',
  },
  // question 01 data
  q1Title: {
    id: 'nMmztR',
    defaultMessage: `What aspects of governing AI responsibly has your organization 
    implemented?`,
  },
  option1Q1: {
    id: 'A6kuBJ',
    defaultMessage: `Contributed externally and shaped industry standards for responsible AI processes and practices`,
    guidance: `Fantastic news. Your organization is well on its way to governing AI responsibly and being a trusted steward of technology.`,
  },
  option2Q1: {
    id: 'O5FA5z',
    defaultMessage: `Adopted new and existing processes and technology for risk 
      management, fallback and failure, monitoring, auditing, and approval 
      or formal discussions of AI projects across the organization`,
    guidance: `Fantastic news. Your organization is well on its way to governing AI responsibly and being a trusted steward of technology. 
    Learn more about IBM’s technology solution for AI governance, watsonx.governance, that can assist you throughout the AI lifecycle.`,
  },
  option3Q1: {
    id: 'J5lTSu',
    defaultMessage: `Defined and partially implemented processes for risk management, 
      monitoring, and auditing, and established a policy to ensure 
      technology aligned with the organization’s values`,
    guidance: `Fantastic news. Your organization is well on its way to governing AI responsibly and being a trusted steward of technology. 
    Learn more about IBM’s technology solution for AI governance, watsonx.governance, that can assist you throughout the AI lifecycle.`,
  },
  option4Q1: {
    id: '8NdSGu',
    defaultMessage:
      'Defined and communicated principles, guidelines and processes for guidance',
    guidance: `Having principles and guidelines defined around
    the responsible use of AI is an essential first step to being a trusted steward of technology. 
    After the principles are defined, the next challenge is putting them into practice. 
    Some ways to accomplishing this goal include implementing a risk management framework or policies to ensure that technology is aligned with the organization’s values. 
    Learn more about the urgency of AI governance to adopt AI at scale.`,
  },
  option5Q1: {
    id: 'CoSzCm',
    defaultMessage: 'Defined principles for responsible AI',
    guidance: `Having principles and guidelines defined around
    the responsible use of AI is an essential first step to being a trusted steward of technology. 
    After the principles are defined, the next challenge is putting them into practice. 
    Some ways to accomplishing this goal include implementing a risk management framework or policies to ensure that technology is aligned with the organization’s values. 
    Learn more about the urgency of AI governance to adopt AI at scale`,
  },
  option6Q1: {
    id: 'xwISzA',
    defaultMessage:
      'Haven’t defined principles and guidelines for responsible AI, although a privacy program is in place, but parallels with AI not considered',
    guidance: `Having principles and guidelines defined around the responsible use of AI is critical to being a trusted steward of technology. 
    Learn more about the urgency of AI governance to adopt AI at scale.`,
  },
  // question 1.1 data
  q1aTitle: {
    id: 'KGhm9F',
    defaultMessage: `Do you have a governing body, in the form of an ethics board or a group of 
    high-level decision-makers to support your AI governance approach?`,
  },
  option1Q1a: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
    guidance: `Excellent. Having a governing body to help your organization better manage AI ethics and policy matters is critical to
    being a steward of responsible AI. At the center of IBM’s trustworthy technology efforts is our AI Ethics Board. 
    To learn how IBM utilizes an AI ethics board to put its principles into practice, visit our AI Ethics webpage.`,
  },
  option2Q1a: {
    id: 'oUWADl',
    defaultMessage: 'No',
    guidance: `For more information on how an AI ethics board
    enabled IBM to put its principles into practice, visit our AI Ethics web
    page. Our consulting team can meet you where you are and assist in
    building the appropriate governing body for your organization.`,
  },
  // question 1.2 data
  q1bTitle: {
    id: 'nwzDZp',
    defaultMessage: `Which of these pictures best exemplifies the makeup of your governing 
    body?`,
  },
  option1Q1b: {
    id: 'rWZ5yC',
    defaultMessage: 'Uniform',
    guidance: `It would be responsible for your organization to ensure that the governing body is truly diverse, inclusive,
    and cross-disciplinary. A diverse team would better capture bias that can be mitigated in the end-to-end lifecycle of AI. 
    For more information on best practices with respect to how these governing bodies should be setup, please check out the World Economic Forum's Empowering AI Leadership Toolkit`,
  },
  option2Q1b: {
    id: 's47Z6j',
    defaultMessage: 'Diversified',
    guidance: `Having a diverse, inclusive, and cross-disciplinary governing body is key. Well done.`,
  },
  // question 02 data
  q2Title: {
    id: '12uQsv',
    defaultMessage: `What practices enforce responsible data management and governance in 
    your organization?`,
  },
  option1Q2: {
    id: '6l/Auj',
    defaultMessage: `Automated data and AI governance that ensures AI models are being 
      audited for bias and discrimination`,
    guidance: `Your organization is on the right track to ensure your data is properly managed and governed.
    Have you considered a data management solution? Check out our eBook: The data store for AI  
    to learn how proper data management can significantly reduce cost, simplify data access and automate unified governance to scale AI.`,
  },
  option2Q2: {
    id: 'pC+SlK',
    defaultMessage: `An actionable data strategy and practices covering data collection, 
      quality and security are in place`,
    guidance: `It is great that you are started on your data management path but know that putting  safeguards or guardrails in place
    for your organization must be a priority in order to help mitigate the risk of fines, penalties, errors, corrupted results and distrust from the market. 
    It is no secret that data plays a crucial role in driving the strategic initiatives of an organization, so data governance and management should be a priority of all organizations.
    Need further guidance? Check out our eBook: The data store for AI  to learn how proper data management can significantly reduce cost, simplify data access and automate unified governance to scale AI.`,
  },
  option3Q2: {
    id: 'VRxnaf',
    defaultMessage: `Ad hoc attempts towards improving data quality, data processing and 
      data understanding; efforts to understand the organization’s data and 
      algorithms`,
    guidance: `It is great that you are started on your data management path but know that putting  safeguards or guardrails in place
    for your organization must be a priority in order to help mitigate the risk of fines, penalties, errors, corrupted results and distrust from the market. 
    It is no secret that data plays a crucial role in driving the strategic initiatives of an organization, so data governance and management should be a priority of all organizations.
    Need further guidance? Check out our eBook: The data store for AI  to learn how proper data management can significantly reduce cost, simplify data access and automate unified governance to scale AI.`,
  },
  option4Q2: {
    id: 'MHXvQj',
    defaultMessage: `Awareness of impact of under-represented data on AI and output 
      quality; extensive data collection with low privacy and security 
      standards`,
    guidance: `It is great that you are started on your data management path but know that putting  safeguards or guardrails in place 
    for your organization must be a priority in order to help mitigate the risk of fines, penalties, errors, corrupted results and distrust from the market. 
    It is no secret that data plays a crucial role in driving the strategic initiatives of an organization, so data governance and management should be a priority of all organizations.
    Need further guidance? Check out our eBook: The data store for AI  to learn how proper data management can significantly reduce cost, simplify data access and automate unified governance to scale AI.`,
  },
  option5Q2: {
    id: 'sf2GMz',
    defaultMessage: `No data management practices and governance in place`,
    guidance: `It is great that you are started on your data management path but know that putting  safeguards or guardrails in place 
    for your organization must be a priority in order to help mitigate the risk of fines, penalties, errors, corrupted results and distrust from the market. 
    It is no secret that data plays a crucial role in driving the strategic initiatives of an organization, so data governance and management should be a priority of all organizations.
    Need further guidance? Check out our eBook: The data store for AI  to learn how proper data management can significantly reduce cost, simplify data access and automate unified governance to scale AI.`,
  },
  // question 03 data
  q3Title: {
    id: 'eZidQC',
    defaultMessage: `To what extent has your organization defined a strategy towards responsible 
    AI and a roadmap to execute that strategy?`,
  },
  option1Q3: {
    id: 'yW6G93',
    defaultMessage: `A vision has been defined that describes responsible AI as a strategic 
      differentiator in the organization strategy and is implemented, 
      monitored and fully integrated with a data and privacy strategy.`,
    guidance: `Your organization is on the right track to ensure a strategy is in place to embrace an AI transformation. 
    Organizations that stay proactive and infuse governance into their AI initiatives from the onset can help minimize risk while strengthening their ability to meet ethical principles and government regulations.
    Get the eBook: Build responsible AI workflows with AI governance to understand the concept of AI governance and benefits of embedding to your technology strategy.`,
  },
  option2Q3: {
    id: '+xTjpj',
    defaultMessage: `A vision on the capabilities and strategic importance of responsible AI 
      is emerging and the organization is mostly following the industry and 
      competition. Some strategic long-term objectives for responsible data 
      and AI use cases have been defined and are being implemented.`,
    guidance: `Your organization is on the right track to ensure a strategy is in place to embrace an AI transformation. 
    Organizations that stay proactive and infuse governance into their AI initiatives from the onset can help minimize risk while strengthening their ability to meet ethical principles and government regulations.
    Get the eBook: Build responsible AI workflows with AI governance to understand the concept of AI governance and benefits of embedding to your technology strategy.`,
  },
  option3Q3: {
    id: 'InATL+',
    defaultMessage: `There’s a general awareness that AI must be curated responsibly. The 
      capabilities and importance of responsible AI are investigated for one 
      or more strategic domains.`,
    guidance: `The advancement of AI doesn’t show any signs of easing up, and the heat is on for organizations like yours to actively address the challenges that come along with it both now and in the future. 
    Whether your organization is considering adopting AI or is further down the journey, establishing an AI governance framework should be part of your strategy.
    Get the eBook: Build responsible AI workflows with AI governance to understand the concept of AI governance and the benefits of embedding it into your technology strategy.`,
  },
  option4Q3: {
    id: '8CWM+w',
    defaultMessage: `Responsible AI isn’t seen as a competitive differentiator and there’s no 
      strategy currently in place.`,
    guidance: `The advancement of AI doesn’t show any signs of easing up, and the heat is on for organizations like yours to actively address the challenges that come along with it both now and in the future. 
    Whether your organization is considering adopting AI or is further down the journey, establishing an AI governance framework should be part of your strategy.
    Get the eBook: Build responsible AI workflows with AI governance to understand the concept of AI governance and the benefits of embedding it into your technology strategy.`,
  },
  // question 04 data
  q4Title: {
    id: 'H8R2IC',
    defaultMessage:
      'To what extent is diversity and cross-disciplinary collaboration enforced in teams and ways of working?',
  },
  option1Q4: {
    id: 'PBHk8x',
    defaultMessage: '10',
    guidance: `Diversity and multidisciplinary efforts are crucial to
    approach AI responsibly. You need to double down on breaking the silos
    that prevent meaningful collaboration. In this way, a more diverse team
    can advocate for more rigorous data sets, design and implementation.`,
  },
  option2Q4: {
    id: '36XRzv',
    defaultMessage: '20',
    guidance: `Your organization is on the right track. Diversity
    and multidisciplinary efforts are crucial to approach AI responsibly. In
    this way, a more diverse team can advocate for more rigorous data sets,
    design and implementation. Continue to drive this collaboration
    throughout the AI lifecycle.`,
  },
  option3Q4: {
    id: 'HMv/M+',
    defaultMessage: '30',
    guidance: `Keep up the good work. It’s vitally important that
    you prioritize ensuring that your data teams are as diverse and
    multidisciplinary as they can possibly be.`,
  },
  // question 05
  q5Title: {
    id: 'Lim4Ig',
    defaultMessage: `To what extent has your organization invested in a transformation strategy 
    to handle AI responsibly?`,
  },
  option1Q5: {
    id: 'GnXI+G',
    defaultMessage: `No budget has been allocated for responsible AI, AI ethics or AI 
    regulation compliance.`,
    guidance: `If little to no budget has been allocated for responsible AI, 
    AI ethics or AI regulation compliance, 
    you need to double down on defining a budget to explore opportunities and resources related to responsible AI.`,
  },
  option2Q5: {
    id: '7edQdH',
    defaultMessage: `Some budget is available to explore opportunities and resources 
    related to responsible AI.`,
    guidance: `Keep up the good work. Some of your budget is
    available to explore opportunities and resources related to responsible AI. 
    Continue to make responsible AI a priority for your organization as it can build trust.`,
  },
  option3Q5: {
    id: 'O2RnxI',
    defaultMessage: `A responsible AI lead has been assigned, who is trying to gather 
    stakeholder support across siloes, but with a limited budget.`,
    guidance: `Appointing someone who is responsible for
    enforcing responsible AI principles is a great step or organization accountability. 
    Continue to make responsible AI a priority for your organization as it can build trust.`,
  },
  option4Q5: {
    id: '+gMdkn',
    defaultMessage: `There’s cross-silo executive commitment to responsible AI, investment 
    in organizational culture and technology infrastructure—including AI 
    governance and tooling—and change management.`,
    guidance: `Keep up the good work.
    It’s important that you prioritize ensuring that budget has been invested to develop a transformation strategy to handle AI responsibly.`,
  },
  // question 6
  q6Title: {
    id: 'Gz40K7',
    defaultMessage: `To what extent is the value of using AI responsibly in your organization 
    understood across all levels and departments?`,
  },
  option1Q6: {
    id: 'ekNzVb',
    defaultMessage: `There’s a general understanding of AI and an improved attitude toward
    using AI responsibly, and an awareness that addressing the 
    organization’s culture to make full use of AI is necessary but difficult, 
    and some communication around the principles and use of AI in the 
    organization.`,
    guidance: `Some progress is being made, which is positive news, but there’s work to be done. Your organization needs to make steps to ensure that the appropriate type and level of skills are in place to embrace an AI transformation.

    There’s no room for complacency and you need to ask:
    
    1. What combination of traditional and emerging tactics will help my organization tackle the skills challenge, especially where foundation models are concerned?
    2. Where should my organization invest its time and money?
    3. Am I able to operationalize my principles and do my practitioners understand how disparate impact may pertain to their use case?
    
    IBM can help you answer these questions.
    For more guidance on how to make your AI investments better align to
    your principles of auditability, explainability and transparency, visit
    
    https://www.ibm.com/consulting/ai-governance 
    `,
  },
  option2Q6: {
    id: 'dYZS03',
    defaultMessage: `Using AI not only directly improves efficiency and decision quality but 
    indirectly changes team culture through its effects on confidence, 
    clarity and morale. There’s effective communication about the use of 
    algorithms, employee-AI interaction and decision-making, and 
    employees recognize the value of responsible AI.`,
    guidance: `Good news—your organization is progressing with operationalizing AI responsibly. You recognize and communicate that you are accountable for the disparate impact of your AI models. Personnel are incentivized to proactively mitigate risk and are stood up as exemplars. It’s likely the business is ready to increase its return on investment and build a broader ecosystem to advocate for responsible use of AI both within and outside the organization.

    Your organization is on the right track to ensure that the appropriate type and level of skills are in place to embrace an AI transformation. However, there’s no room for complacency, and you need to ask:
    
    1. What combination of traditional and emerging tactics will help my organization tackle the skills challenge, especially where foundation models are concerned?
    2. Where should my organization invest its time and money?
    3. Am I able to operationalize my principles and do my practitioners understand how disparate impact may pertain to their use case?
    
    IBM can help you answer these questions.
    For more guidance on how to make your AI investments better align to
    your principles of auditability, explainability and transparency, visit
    
    https://www.ibm.com/consulting/ai-governance 
    `,
  },
  option3Q6: {
    id: 'IxgqBV',
    defaultMessage: `The overall culture is characterized by a general mistrust and fear of AI
    and employees react to change with surprise and can be resistant.`,
    guidance: `Unfortunately, this culture is likely to be a problem for your organization.  Your organization needs to make steps to ensure that the appropriate type and level of skills are in place to embrace an AI transformation.

    There’s no room for complacency, and you need to ask:
    
    1. What combination of traditional and emerging tactics will help my organization tackle the skills challenge, especially where foundation models are concerned?
    2. Where should my organization invest its time and money?
    3. Am I able to operationalize my principles and do my practitioners understand how disparate impact may pertain to their use case?
    
    IBM can help you answer these questions.
    For more guidance on how to make your AI investments better align to
    your principles of auditability, explainability and transparency, visit
    
    https://www.ibm.com/consulting/ai-governance 
    `,
  },
  // question 7
  q7Title: {
    id: 'Oscu20',
    defaultMessage: `What’s the effort in the organization to increase knowledge and 
    understanding of using AI responsibly?`,
  },
  option1Q7: {
    id: 'HW8F4t',
    defaultMessage: `No effort - The need to train practitioners is identified; employees are free to 
    pursue education independently.`,
    guidance: `This lack of effort results in a low score overall,
    showing awareness in some areas, but inactivity in others. However, there’s guidance we can provide to help your organization improve.
    
    Proactive education and training across the organization is key. Without it, the risk of potentially unethical AI use cases being deployed and, in turn, the risk of reputational damage or compliance violations increases.
    
    Employees across all levels and disciplines should be familiar with the principles of using and designing AI responsibly, and the risks of not doing so. Mandatory accreditation should be in place for decision and policy makers.
    
    To scale AI effectively and safely, and adhere to corporate AI principles and vision, IBM has put in place business unit ethics representatives— AI Ethics Focal Points—who communicate directly with the AI Ethics Board, and an advocacy network of employees who promote the ethical culture and use of AI within their teams.
    
    To take a deeper look into IBM’s governance framework, read this blog that highlights a Gartner case study, featuring IBM, about how to establish a governance framework to streamline the process of detecting and managing technology ethics concerns in AI projects. 
    
    We can provide guidance on the culture needed to adopt and scale AI safely, the AI engineering with forensic tools to see inside black box algorithms and governance to make sure the engineering 'sticks' to the culture and principles.
    
    For more help, visit https://www.ibm.com/consulting/ai-governance . We can proactively help you assess AI governance gaps with respect to upcoming regulations, like the EU AI Act, and establish the right organizational culture to operationalize your principles.
    `,
  },
  option2Q7: {
    id: 'L76VGh',
    defaultMessage: `Some effort - Selected, mainly technical, people in the organization are actively 
    encouraged to pursue education on using and designing AI responsibly;
    training recommendations are provided for interested employees.`,
    guidance: `Your overall scores show evidence of positive activity and some items that are operational - but there is still work to be done and gaps to be addressed for your organization to stay on top of new regulations and changing business needs.

    Employees across all levels and disciplines should be familiar with the principles of using and designing AI responsibly, and the risks of not doing so. Mandatory accreditation should be in place for decision and policy makers.
    
    To scale AI effectively and safely, and adhere to corporate AI principles and vision, IBM has put in place business unit ethics representatives— AI Ethics Focal Points—who communicate directly with the AI Ethics Board, and an advocacy network of employees who promote the ethical culture and use of AI within their teams.
    
    To take a deeper look into IBM’s governance framework, read this blog that highlights a Gartner case study, featuring IBM, about how to establish a governance framework to streamline the process of detecting and managing technology ethics concerns in AI projects. 
    
    We can provide guidance on the culture needed to adopt and scale AI safely, the AI engineering with forensic tools to see inside black box algorithms and governance to make sure the engineering 'sticks' to the culture and principles.
    
    For more help, visit https://www.ibm.com/consulting/ai-governance . We can proactively help you assess AI governance gaps with respect to upcoming regulations, like the EU AI Act, and establish the right organizational culture to operationalize your principles.
    `,
  },
  option3Q7: {
    id: 'z+SdpE',
    defaultMessage: `Reasonable amount of effort - AI training curricula are developed for leaders and practitioners that 
    emphasize trustworthiness; a guild curates responsible AI design 
    thinking frameworks on which practitioners are trained.`,
    guidance: `Your overall scores show evidence of positive activity and some items that are operational - but there is still work to be done and gaps to be addressed for your organization to stay on top of new regulations and changing business needs.

    Employees across all levels and disciplines should be familiar with the principles of using and designing AI responsibly, and the risks of not doing so. Mandatory accreditation should be in place for decision and policy makers.
    
    To scale AI effectively and safely, and adhere to corporate AI principles and vision, IBM has put in place business unit ethics representatives— AI Ethics Focal Points—who communicate directly with the AI Ethics Board, and an advocacy network of employees who promote the ethical culture and use of AI within their teams.
    
    To take a deeper look into IBM’s governance framework, read this blog that highlights a Gartner case study, featuring IBM, about how to establish a governance framework to streamline the process of detecting and managing technology ethics concerns in AI projects. 
    
    We can provide guidance on the culture needed to adopt and scale AI safely, the AI engineering with forensic tools to see inside black box algorithms and governance to make sure the engineering 'sticks' to the culture and principles.
    
    For more help, visit https://www.ibm.com/consulting/ai-governance . We can proactively help you assess AI governance gaps with respect to upcoming regulations, like the EU AI Act, and establish the right organizational culture to operationalize your principles.
    `,
  },
  option4Q7: {
    id: 'f7Y9YG',
    defaultMessage: `High effort - There’s mandatory accreditation for practitioners and leaders working 
    in the field of AI; training and assets are continually updated; there’s 
    proactive mentoring for AI practitioners.`,
    guidance: `This score indicates the enterprise is making systemic progress with several operational areas and transforming the organization. The business is ready to increase its return on investment and build an even broader ecosystem to advocate for responsible use of AI both within and outside the organization.

    We encourage you to train practitioners and provide the opportunity to work on global, diverse, inclusive multi-disciplinary teams on projects for trusted systems. Defining a Center of Excellence is an example of providing an environment for practitioners to seek guidance.
    
    We can provide guidance on the culture needed to adopt and scale AI safely, the AI engineering with forensic tools to see inside black box algorithms and governance to make sure the engineering 'sticks' to the culture and principles.
    
    For more help, visit https://www.ibm.com/consulting/ai-governance . We can proactively help you assess AI governance gaps with respect to upcoming regulations, like the EU AI Act, and establish the right organizational culture to operationalize your principles.
    `,
  },
  // question 8
  q8Title: {
    id: 'BBm2Yx',
    defaultMessage: `How are AI projects initiated and what roles do ethics and compliance play in
    the design process?`,
  },
  option1Q8: {
    id: 'M+6Q4M',
    defaultMessage: `There’s no methodology for developing AI responsibly.`,
    guidance: `Unfortunately this is likely to be a problem for your organization.

    A design and development guiding framework is needed to integrate technical ethics solutions into the technology lifecycle and development pipeline, both for AI and other applicable algorithmic systems.  
    
    The framework should be embedded in the organization’s governance structure, e.g. through a corporate level directive and complement other security and privacy practices.
    
    The design framework, and deployment method (updated and communicated via a playbook) support the responsible development of AI and other technologies.
    
    Systems owners should be trained and required to follow the design methodology. 
    
    A design framework demonstrates commitment to ethical principles such as Trust and Transparency – and paired with a ‘playbook’ proscribes the tools, methods, and best practices that developers and data scientists should use to integrate tech ethics into their everyday jobs.
    
    The work does not stop there. We can help you also offer applied training to practitioners so that they understand how to apply principles to their use case. It’s one thing to read about explainability or fairness and it is quite another to do a deep dive into a use case. For more help, visit https://www.ibm.com/consulting/ai-governance 
    `,
  },
  option2Q8: {
    id: 'Q+v2FR',
    defaultMessage: `There’s awareness that design is an important phase where decisions 
    on the responsible use of AI are made.`,
    guidance: `Awareness is good, but there is work to be done.

    A design and development guiding framework is needed to integrate technical ethics solutions into the technology lifecycle and development pipeline, both for AI and other applicable algorithmic systems.  
    
    The framework should be embedded in the organization’s governance structure, e.g. through a corporate level directive and complement other security and privacy practices.
    
    The design framework, and deployment method (updated and communicated via a playbook) support the responsible development of AI and other technologies.
    
    Systems owners should be trained and required to follow the design methodology. 
    
    A design framework demonstrates commitment to ethical principles such as Trust and Transparency – and paired with a ‘playbook’ proscribes the tools, methods, and best practices that developers and data scientists should use to integrate tech ethics into their everyday jobs.
    
    The work does not stop there. We can help you also offer applied training to practitioners so that they understand how to apply principles to their use case. It’s one thing to read about explainability or fairness and it is quite another to do a deep dive into a use case. For more help, visit https://www.ibm.com/consulting/ai-governance 
    `,
  },
  option3Q8: {
    id: 'jnjstH',
    defaultMessage: `Artifacts are in place to make principles actionable for practitioners 
    during the design phase. Practitioners from diverse backgrounds strive 
    toward the simplest possible solution, with human oversight and 
    testing.`,
    guidance: `This is good news - your organization is making progress with operationalising design.  It's likely the business is ready to increase its return on investment and build a broader ecosystem to advocate for responsible use of AI both within and outside the organization..  

    The framework should be embedded in the organization’s governance structure, e.g. through a corporate level directive and complement other security and privacy practices.
    
    The design framework, and deployment method (updated and communicated via a playbook) support the responsible development of AI and other technologies.
    
    Systems owners should be trained and required to follow the design methodology. 
    
    A design framework demonstrates commitment to ethical principles such as Trust and Transparency – and paired with a ‘playbook’ proscribes the tools, methods, and best practices that developers and data scientists should use to integrate tech ethics into their everyday jobs. 
    
    The work does not stop there. We can help you also offer applied training to practitioners so that they understand how to apply principles to their use case. It’s one thing to read about explainability or fairness and it is quite another to do a deep dive into a use case. For more help, visit https://www.ibm.com/consulting/ai-governance 
    `,
  },
  // question 09
  q9Title: {
    id: 'nlMVYL',
    defaultMessage: `Is your organization monitoring compliance with existing regulations, such as
    the EU AI Act, and ready to comply with upcoming AI regulations?`,
  },
  option1Q9: {
    id: 'a5msuh',
    defaultMessage: `Yes`,
    guidance: `This is good news for your organization - you understand that there is no room for complacency. You must now ensure that compliance is enforced.

    wo thirds of countries across the world have some form of Privacy law and enforcement continues to increase. AI Regulations are already here, including:
    
    -The NYC Council AI Law, enforced in 2023. 
    -The EU AI Regulation includes fines of up to 7% of a company’s annual revenues for non-compliance.
    
    The IBM Office of Privacy and Responsible Technology helps to simplify and automate global privacy and AI compliance tasks for machine learning models managed by IBM. Learn more in the case study
    
    IBM also has services that assess your current AI governance framework with respect to current and upcoming regulatory requirements, and offer a deep dive analysis on your AI maturity
    https://www.ibm.com/consulting/ai-governance 
    
    IBM also has products that can help your organisation prepare for regulatory requirements  watsonx.governance
    `,
  },
  option2Q9: {
    id: 'oUWADl',
    defaultMessage: `No`,
    guidance: `Your organization needs to understand that there is no room for complacency.
    You are increasing the risk of fines and reputational damage as a result of compliance violations.
    
    Two thirds of countries across the world have some form of Privacy law and enforcement continues to increase. AI Regulations are already here, including:
    
    -The NYC Council AI Law, enforced in 2023. 
    -The EU AI Regulation includes fines of up to 7% of a company’s annual revenues for non-compliance.
    
    The IBM Office of Privacy and Responsible Technology helps to simplify and automate global privacy and AI compliance tasks for machine learning models managed by IBM. Learn more in the case study
    
    IBM also has services that assess your current AI governance framework with respect to current and upcoming regulatory requirements, and offer a deep dive analysis on your AI maturity
    https://www.ibm.com/consulting/ai-governance 
    
    IBM also has products that can help your organisation prepare for regulatory requirements  watsonx.governance
    `,
  },
  // success screen data
  successTitle: {
    id: 'ox5yCv',
    defaultMessage: 'Great Job!',
  },
  successCopy: {
    id: '+tqq8R',
    defaultMessage:
      'This was just a small sample of the holistic assessment process that we conduct with clients. Click below to see your results!',
  },
  successButtonBack: {
    id: 'fGKnYe',
    defaultMessage: 'Back to questions',
  },
  successButtonResults: {
    id: 'dwL4wm',
    defaultMessage: 'View results',
  },
  // results data
  resultsTitle: {
    id: 'oWz8km',
    defaultMessage: 'Score & Output',
  },
  resultsCopy: {
    id: 'f1Q7K5',
    defaultMessage: `Bravo! Let's check the results...`,
  },
  buttonRestart: {
    id: '5kK+j9',
    defaultMessage: 'Restart',
  },
  buttonSave: {
    id: 'S0nSE2',
    defaultMessage: 'Save Results',
  },
  summaryLabel: {
    id: 'RrCui3',
    defaultMessage: 'Summary',
  },
  summaryCopy: {
    id: 'zWf2U3',
    defaultMessage: `Our goal is to help clients build responsible AI. To do it well, organizations need a combination of people and automation tools. People bring values, adaptiveness, and responsibility, while tools bring automation, scale, reproducibility and interoperability.

    We can help our clients with the culture they need to adopt and scale AI safely, the AI engineering with forensic tools to see inside black box algorithms and governance to make sure the engineering 'sticks' to the culture.`,
  },
  summaryScroll: {
    id: 'ZzDoSC',
    defaultMessage: 'Scroll down to read our feedback ↓',
  },
  summaryLinksTitle: {
    id: 'NJR+Mx',
    defaultMessage: 'Other resources',
  },
  summaryLink1: {
    id: 'eOC8dq',
    defaultMessage: `IBM's approach to Responsible AI`,
  },
  summaryLink2: {
    id: '5sY9/v',
    defaultMessage:
      'Our AI Academy on preparing for responsible AI regulations',
  },
  summaryLink3: {
    id: '+nuOeh',
    defaultMessage: 'AI governance Consulting Services',
  },
  summarySpeakToExpert: {
    id: 'arJllJ',
    defaultMessage: 'Our team is here to be your partner along your journey.',
  },
  summarySpeakToExpertButton: {
    id: '5UWHWS',
    defaultMessage: 'Speak to an expert',
  },
  governanceLabel: {
    id: 'NIKzHA',
    defaultMessage: 'Strategy & Governance',
  },
  forensicLabel: {
    id: 'W2rDER',
    defaultMessage: 'Data & Technology',
  },
  cultureLabel: {
    id: '9bYJ6P',
    defaultMessage: 'People & Culture ',
  },
  graphicStrategy: {
    id: 'jdjd',
    defaultMessage: 'Strategy',
  },
  graphicData: {
    id: 'kdosow',
    defaultMessage: 'Data',
  },
  graphicPeople: {
    id: 'bcjskd',
    defaultMessage: 'People',
  },
  graphicCaption: {
    id: 'jfkssl',
    defaultMessage: 'Score',
  },
  minRecomendation: {
    id: 'fkke',
    defaultMessage: 'More focus needed',
  },
  mediumRecomendation: {
    id: 'fkkews',
    defaultMessage: 'On your way',
  },
  maxRecomendation: {
    id: 'fkke',
    defaultMessage: 'Ahead of most',
  },
});

export default messages;
